import * as React from 'react';

import { PREMIUM_STATE_LOCKED, PREMIUM_STATE_NONE, SKILLS_REPORT_IMG_SRC, } from '../shared/shared'
import { LARGE_ICON_BASE_SRC, } from '../../../../Shared/index'
import { requestPost, } from '../../../../../modules/request'

const productBezelImg = <img alt="" className="product-bezel" src={`${SKILLS_REPORT_IMG_SRC}/product_bezel@2x.png`} />
const studentAccountsImg = <img alt="" src={`${LARGE_ICON_BASE_SRC}/student-accounts.svg`} />
const packsWholeImg = <img alt="" src={`${LARGE_ICON_BASE_SRC}/packs-whole.svg`} />
const activityPacksImg = <img alt="" src={`${LARGE_ICON_BASE_SRC}/activity-packs.svg`} />
const shannonHeadshotImg = <img alt="" src={`${SKILLS_REPORT_IMG_SRC}/shannon_headshot.svg`} />

interface LockedPageProps {
  premiumState: typeof PREMIUM_STATE_LOCKED | typeof PREMIUM_STATE_NONE;
}

const LockedPage = ({ premiumState, }: LockedPageProps) => {
  const beginTrial = () => {
    requestPost('/subscriptions', { subscription: { account_type: 'Teacher Trial', }, }, () => {
      window.location.reload()
    })
  }
  
  return (
    <div className="skills-report-locked-page container">
      <header>
        <span className="new-tag">NEW</span>
        <h1>Skills Report</h1>
        <p className="sub-header">See the full story of skill growth with complete learning history and actionable groups. Included with Quill Premium.</p>
      </header>
      <div className="buttons-wrapper">
        {premiumState !== PREMIUM_STATE_LOCKED && <button className="quill-button contained gold large focus-on-light" onClick={beginTrial} type="button">Try Premium free for 30 days</button>}
        <a className="quill-button contained gold large focus-on-light" href="/premium" rel="noopener noreferrer" target="_blank">Learn more about Premium</a>
      </div>
      {productBezelImg}
      <h2>Why Teachers Love This Report</h2>
      <section className="reasons">
        <div className="reason">
          {studentAccountsImg}
          <h3>Complete Learning History</h3>
          <p>Get an accurate baseline of student ability from day one. Powered by a student’s full Quill history across teachers and classes, it gives a complete picture of their understanding.</p>
        </div>
        <div className="reason">
          {packsWholeImg}
          <h3>Growth-Focused Scores</h3>
          <p>Based on Quill’s proprietary algorithm, the Momentum Score celebrates the learning process. It values recent improvement and consistent effort, ensuring early mistakes never define a student’s potential.</p>
        </div>
        <div className="reason">
          {activityPacksImg}
          <h3>Actionable Smart Groups</h3>
          <p>Set your own goal, and Smart Groups adapt. Students are automatically organized into categories like Needs Support or Meeting Goal, so you can assign targeted practice with a single click.</p>
        </div>
      </section>
      <section className="testimonial">
        {shannonHeadshotImg}
        <p className="quote">“The Skills Report gives teachers a clearer way to understand student growth. Instead of static scores, they can see improvement and persistence over time. With Smart Groups adapting to their goals, teachers know exactly who needs support and where to focus instruction.”</p>
        <p className="attribution">Shannon Browne, Professional Learning Manager</p>
      </section>
    </div>
  )
}

export default LockedPage
